module.exports = __webpack_public_path__ + "static/img/background_image.png";